export default __webpack_public_path__ + "static/media/promos-banner-cn.26fbee11.webp";